module.exports = __webpack_public_path__ + "static/img/基因编辑.6b687d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/基因编辑.jpg
// module id = XCxc
// module chunks = 1